module.exports = __webpack_public_path__ + "static/pay-by-link-atelier-animation-1ffe02080a49d40f36a629b8fa5fcc6c.mp4";